(function openTabData() {
    $('[data-tab-id]').bind('click', function() {
        var id = $(this).attr('data-tab-id');

        $('[data-tab-id]').removeClass('active');
        $(this).addClass('active');

        $('[data-tab-content-id]').addClass('hidden');
        $('[data-tab-content-id="' + id +'"]').removeClass('hidden');

        $('[data-tab-current-id]').val(id);
    });
})();


(function scrollTabsLeft() {
    $('.scroll-left').click(function () {
        var target = $(this).attr('data-target');
        var step = $(target).outerWidth();
        var ul = $(target + ' ul');
        var correction = $(target + ' ul li').outerWidth();
        var width = step/2 - (correction);
        event.preventDefault();
        if ($(ul).outerWidth() > $(target).outerWidth()) {
            $(ul).stop().animate({
                left: '+=' + width + 'px'
            }, 800);
        }
    });
})();

(function scrollTabsRight() {
    $('.scroll-right').click(function () {
        var target = $(this).attr('data-target');
        var step = $(target).outerWidth();
        var ul = $(target + ' ul');
        var correction = $(target + ' ul li').outerWidth();
        var width = step/2 - (correction);
        console.log(width);
        event.preventDefault();
        if ($(ul).outerWidth() > $(target).outerWidth()) {
            $(ul).stop().animate({
                left: '-=' + width + 'px'
            }, 800);
        }
    });
})();